module.exports = __webpack_public_path__ + "fonts/opensans-bolditalic.2764751c.woff2";